import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { ProductCardWidgetData } from '@web/widgets/product-card/type';
import type { Classes } from 'jss';
import {
    BUTTON_SIZE_CLASS_MAP,
    BUTTON_TYPE_CLASS_MAP,
    DEFAULT_BUTTON_CLASS,
} from '@web/widgets/common/base/base-button/base-button.const';
import { EButtonStyleType } from '@common/enums';
import { type SelectedFileExtended } from '@common/types/file.type';
import { type ProductCard, type ProductUnits } from '@common/types/product-card.type';
import { SpSafeHtmlPipe } from '@common/pipes/safe-html.pipe';

import { environment } from '@web-env/environment';
import { formatFileUrl, formatFileUrlWithResize } from '@components/sp-file-manager/src/helpers';
import { SppFallbackImgDirective } from '@common/directives/fallback-img.directive';

@Component({
    selector: 'web-product-card-modal',
    templateUrl: './product-card-modal.component.html',
    styleUrls: ['./product-card-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpSafeHtmlPipe, SppFallbackImgDirective],
})
export class ProductCardModalComponent {
    @Input() data: ProductCardWidgetData;
    @Input() classes: Classes;

    public get element(): ProductCardWidgetData['element'] {
        return this.data?.element;
    }

    public get images(): ProductCard['images'] {
        return this.element?.images;
    }

    public get basketButton(): ProductCardWidgetData['basketButton'] {
        return this.data?.basketButton;
    }

    public get getBasketButtonStyles(): string {
        const styles = `${DEFAULT_BUTTON_CLASS} ${BUTTON_SIZE_CLASS_MAP[this.data.basketButton.size]}`;
        const shadowClass = this.classes?.basketButtonShadow ?? '';

        if (this.basketButton.styleType === EButtonStyleType.custom) {
            return `${styles} ${this.classes?.buttonStyles} ${shadowClass}`;
        }

        return `${styles} ${BUTTON_TYPE_CLASS_MAP[this.basketButton?.styleType]} ${this.classes?.buttonStyles} ${shadowClass}`;
    }

    private get quantity(): number {
        return this.element?.quantity;
    }

    public get unit(): ProductUnits {
        return this.element?.unit;
    }

    public formatImageURLWithResize(image: SelectedFileExtended): string {
        return formatFileUrlWithResize(image, environment.fileManagerCdnUrl, 720);
    }

    public formatImageURL(image: SelectedFileExtended): string {
        return formatFileUrl(image, environment.fileManagerCdnUrl);
    }
}
